export default "__VITE_ASSET__BJy6RkLt__"